import React, { startTransition } from "react";
import css from "./InsightsLayout.module.scss";
import Sidebar from "./Sidebar/Sidebar";
import { Outlet, useMatch } from "react-router-dom";
import { NativeSelect } from "@mantine/core";
import useAnalyticsStore from "stores/useAnalyticsStore";
import { useUser } from "stores/useUser";
import InsightsDrilldownHost from "components/Insights/Drilldown/InsightsDrilldownHost";

const InsightsLayout = () => {
  const isOrganization = useMatch("/insights/organization");
  const isMyTime = useMatch("/insights/me-time");
  const isOrganizer = useMatch("/insights/me-time/organizer");
  const isAttendee = useMatch("/insights/me-time/attendee");
  const { duration, setDuration } = useAnalyticsStore();
  const {
    user: { email },
  } = useUser();
  return (
    <div className={css.container}>
      {/* sidebar  */}
      <Sidebar />

      {/* content */}
      <div className={css.analytics}>
        {!isOrganization && !isMyTime && !isOrganizer && !isAttendee && (
          <div className={css.header}>
            <h2>
              {duration === 7
                ? "Weekly"
                : duration === 30
                  ? "Monthly"
                  : duration === 90 && "Three Month"}{" "}
              Statistics
            </h2>
            <div className={css.duration}>
              <span>Duration</span>
              <NativeSelect
                radius="xl"
                size="xs"
                value={duration}
                data={[
                  { value: 7, label: "prev week" },
                  { value: 30, label: "prev month" },
                  { value: 90, label: "prev 3 months" },
                ]}
                onChange={(event) =>
                  startTransition(() => {
                    setDuration(parseInt(event.currentTarget.value));
                  })
                }
              />
            </div>
          </div>
        )}
        <Outlet context={[email]} />
      </div>

      {/* One drill-down popup for every card, opened by the URL. */}
      <InsightsDrilldownHost />
    </div>
  );
};

export default InsightsLayout;
